<template>
      <div no-body class="lku-salesorder"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
        <b-col lg="12">
            <b-input-group >
                <b-input-group-prepend><label >Customer</label></b-input-group-prepend>
                <b-form-input v-model="tblData.customer" placeholder="Pemasang/Biro Iklan" :disabled="((customer_id||'') !== '')" ></b-form-input>
                <b-form-input v-model="tblData.Advertiser" placeholder="Advertiser"  class="ml-1"></b-form-input>
                <b-input-group-prepend><span class="p-2" >Invoicing</span></b-input-group-prepend>                  
                  <b-form-select v-model="tblData.completed" :plain="true" :options="YesNoAll"></b-form-select>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Order Number </label></b-input-group-prepend>
                  <b-form-input v-model="tblData.nomor"  placeholder="Order Number"></b-form-input>
                  <b-input-group-prepend><span class="p-2" >Description</span></b-input-group-prepend>                  
                    <b-form-input v-model="tblData.uraian"  placeholder="Description"></b-form-input>
                  <b-input-group-append>
                    <b-button class="btn btn-success ml-1" @click="search()" size="sm">
                      <i class="fa fa-search"></i> Search
                    </b-button>
                    <b-button class="btn btn-secondary ml-1" @click="clearFilter()" size="sm">
                      <i class="fa fa-eraser"></i>Clear
                    </b-button>
                  </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblSalesOrder" style="font-size:smaller;" 
          responsive small striped hover
          :items="tblData.items"
          :fields="fields"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="updatetable" 
          @row-clicked="selectItem"
        >
        <template v-slot:cell(documentReqUploadTotal)="data">
          <span :style="{'background-color':`${data.item.documentReqUploadTotal==data.item.documentReqTotal?'#04f681':''}`}">{{ data.item.documentReqUploadTotal }} of {{ data.item.documentReqTotal }}</span>
        </template>
        <template v-slot:cell(OrderDate)="data">
          {{ data.item.OrderDate | moment("DD MMM YYYY") }}
        </template>
          <template v-slot:cell(ttlamtdue)="data">
              {{data.item.ttlamtdue | numFormat}}
          </template>
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
  </div>
</template>
<style lang="scss">
  .lku-salesorder {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import salesorder from "../../apis/salesorder";

export default {
  data() {
    return {
      lkuLoading:false,
      fields: [
          {
            key: "nomor",
            label: "Order Number",
            sortable: true
          },
          {
            key: "OrderDate",
            thStyle: "width:90px",
            label: "Date",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "custinfo",
            label: "Customer",
            sortable: true
          },
          {
            key: "uraian",
            label: "Description",
            sortable: true
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "ttlamtdue",
            label: "Invoice Amount",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
          key: "documentReqUploadTotal",
          label: "Document Upload",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        },
      ],
      tblData: {
        items:[],
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'nomor',
        sortDesc: false,
        customer_id:''
      },
      YesNoAll :   [{ value: 0, text: 'Un Complete' }, { value: 1, text: 'Complete' }, { value: '', text: '--ALL--' }],
      updatetable:false
    };
  },
  computed: {
    filterCustomer() {
      return this.tblData.customer;
    },
    filtercustcode() {
      return this.tblData.customer_id;
    },
    pagechange() {
      return this.tblData.page;
    },
    limitchange() {
      return this.tblData.limit;
    },
  },
  watch: {
    filterCustomer: function(newval) {
      this.$emit('update:customer', newval);
    },    
    filtercustcode: function(newval) {
      this.$emit('update:customer_id', newval);
    },   
    pagechange: function(newval) {
      this.tblData.page=newval;
      this.refresh();
    },   
    limitchange: function(newval) {
      this.data();
    },   
  },
  props: ["customer", "customer_id","status","completed"],
  created: async function() {
      this.tblData.customer=this.customer || '';
      this.tblData.customer_id=this.customer_id || '';
      this.tblData.completed=this.completed || '0';
      this.data();
 },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function() {
      if (this.status){
        this.tblData.status=this.status;
      }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading=true;
      const list = await salesorder.list(this.tblData);      
      this.lkuLoading=false;
      this.tblData.items=list;
      this.updatetable=!this.updatetable;
      // console.log('this.tblData : ',this.tblData);
    },
    selectItem(item,index) {
      // this.$emit("click", item);
      this.tblData.selected=item;
      this.$emit("click", item);
    },
    clearFilter() {
        this.Advertiser=  '';
        this.tblData.customer= '';
        this.tblData.customer_id=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.completed='0';
    },    
    keymonitor: function(event) {
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblSalesOrder.refresh();
       }
    },    
    search() {
      this.tblData.page=1;
      this.data();
      this.$refs.tblSalesOrder.refresh();
    },
    refresh() {
      this.data();
      this.$refs.tblSalesOrder.refresh();
    }
  }
};
</script>
